import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

window.Pusher = Pusher;

window.Echo = new Echo({
	broadcaster: 'pusher',
	encrypted: true,
	forceTLS: true,
	...window.pusherConfig,
});
